/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { ReferralRecipientInput } from './ReferralRecipientInput';
import {
    ReferralRecipientInputFromJSON,
    ReferralRecipientInputFromJSONTyped,
    ReferralRecipientInputToJSON,
    ReferralRecipientInputToJSONTyped,
} from './ReferralRecipientInput';
import type { ReferralDocumentInput } from './ReferralDocumentInput';
import {
    ReferralDocumentInputFromJSON,
    ReferralDocumentInputFromJSONTyped,
    ReferralDocumentInputToJSON,
    ReferralDocumentInputToJSONTyped,
} from './ReferralDocumentInput';
import type { GeneratedReferralDocumentInput } from './GeneratedReferralDocumentInput';
import {
    GeneratedReferralDocumentInputFromJSON,
    GeneratedReferralDocumentInputFromJSONTyped,
    GeneratedReferralDocumentInputToJSON,
    GeneratedReferralDocumentInputToJSONTyped,
} from './GeneratedReferralDocumentInput';

/**
 * 
 * @export
 * @interface SendLeadReferralRequest
 */
export interface SendLeadReferralRequest {
    /**
     * 
     */
    sender_facility_id: number;
    /**
     * 
     */
    sender_organization_id: number;
    /**
     * Required when date_type is manual (or omitted). Ignored for start_of_care/end_of_care — the server resolves and keeps this value fresh from the lead's admission status instead.
     */
    target_discharge_date?: Date;
    /**
     * manual: target_discharge_date is a literal date set by the sender. start_of_care/end_of_care: the date is derived from the lead's admission status and kept in sync server-side; any target_discharge_date sent with these is ignored.
     */
    date_type?: SendLeadReferralRequestDateTypeEnum;
    /**
     * 
     */
    referral_type: SendLeadReferralRequestReferralTypeEnum;
    /**
     * 
     */
    first_name?: string;
    /**
     * 
     */
    last_name?: string;
    /**
     * 
     */
    ssn?: string;
    /**
     * 
     */
    dob?: Date;
    /**
     * 
     */
    recipients: Array<ReferralRecipientInput>;
    /**
     * 
     */
    documents: Array<ReferralDocumentInput>;
    /**
     * Documents identified by their generated-document type rather than an existing screener_documents row (e.g. PCC-sourced reports, which are regenerated in place and never get their own lead document row). The server resolves the current record for the lead at send time.
     */
    generated_documents?: Array<GeneratedReferralDocumentInput>;
    /**
     * Optional message broadcast to all recipients on referral creation
     */
    initial_message?: string;
}


/**
 * @export
 */
export const SendLeadReferralRequestDateTypeEnum = {
    Manual: 'manual',
    StartOfCare: 'start_of_care',
    EndOfCare: 'end_of_care',
} as const;
export type SendLeadReferralRequestDateTypeEnum = typeof SendLeadReferralRequestDateTypeEnum[keyof typeof SendLeadReferralRequestDateTypeEnum];

/**
 * @export
 */
export const SendLeadReferralRequestReferralTypeEnum = {
    HomeHealth: 'home_health',
    Hospice: 'hospice',
    Snf: 'snf',
    Ltac: 'ltac',
    Dme: 'dme',
    Dialysis: 'dialysis',
    Other: 'other',
} as const;
export type SendLeadReferralRequestReferralTypeEnum = typeof SendLeadReferralRequestReferralTypeEnum[keyof typeof SendLeadReferralRequestReferralTypeEnum];


/**
 * Check if a given object implements the SendLeadReferralRequest interface.
 */
export function instanceOfSendLeadReferralRequest(value: object): value is SendLeadReferralRequest {
    if (!('sender_facility_id' in value) || value['sender_facility_id'] === undefined) return false;
    if (!('sender_organization_id' in value) || value['sender_organization_id'] === undefined) return false;
    if (!('referral_type' in value) || value['referral_type'] === undefined) return false;
    if (!('recipients' in value) || value['recipients'] === undefined) return false;
    if (!('documents' in value) || value['documents'] === undefined) return false;
    return true;
}

export function SendLeadReferralRequestFromJSON(json: any): SendLeadReferralRequest {
    return SendLeadReferralRequestFromJSONTyped(json, false);
}

export function SendLeadReferralRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendLeadReferralRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sender_facility_id': json['sender_facility_id'],
        'sender_organization_id': json['sender_organization_id'],
        'target_discharge_date': json['target_discharge_date'] == null ? undefined : (parseDate(json['target_discharge_date'])),
        'date_type': json['date_type'] == null ? undefined : json['date_type'],
        'referral_type': json['referral_type'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'dob': json['dob'] == null ? undefined : (parseDate(json['dob'])),
        'recipients': ((json['recipients'] as Array<any>).map(ReferralRecipientInputFromJSON)),
        'documents': ((json['documents'] as Array<any>).map(ReferralDocumentInputFromJSON)),
        'generated_documents': json['generated_documents'] == null ? undefined : ((json['generated_documents'] as Array<any>).map(GeneratedReferralDocumentInputFromJSON)),
        'initial_message': json['initial_message'] == null ? undefined : json['initial_message'],
    };
}

export function SendLeadReferralRequestToJSON(json: any): SendLeadReferralRequest {
    return SendLeadReferralRequestToJSONTyped(json, false);
}

export function SendLeadReferralRequestToJSONTyped(value?: SendLeadReferralRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sender_facility_id': value['sender_facility_id'],
        'sender_organization_id': value['sender_organization_id'],
        'target_discharge_date': value['target_discharge_date'] == null ? value['target_discharge_date'] : serializeDate(value['target_discharge_date']),
        'date_type': value['date_type'],
        'referral_type': value['referral_type'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'ssn': value['ssn'],
        'dob': value['dob'] == null ? value['dob'] : serializeDate(value['dob']),
        'recipients': ((value['recipients'] as Array<any>).map(ReferralRecipientInputToJSON)),
        'documents': ((value['documents'] as Array<any>).map(ReferralDocumentInputToJSON)),
        'generated_documents': value['generated_documents'] == null ? undefined : ((value['generated_documents'] as Array<any>).map(GeneratedReferralDocumentInputToJSON)),
        'initial_message': value['initial_message'],
    };
}

